// product-page.js — click-to-zoom, vertical rail scroll, working arrows
(function(){
  function log(){ try{ console.log('[BLS]', ...arguments); }catch(e){} }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init(){
    const root = document.getElementById('bls-product');
    if(!root){ return; }

    // Currency: prefer store’s active money format; fallback pattern
    const MONEY_FORMAT = root.dataset.moneyWithCurrencyFormat || root.dataset.moneyFormat || null;

    function withThousands(n, sep){
      const parts = n.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, sep);
      return parts.join('.');
    }
    function fmtFromPattern(cents, pattern){
      const abs = Math.abs(cents);
      const val = abs/100;
      let out = pattern || '{{amount}}';
      if (out.includes('{{amount_no_decimals_with_comma_separator}}')){
        const n = Math.round(val).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        out = out.replace('{{amount_no_decimals_with_comma_separator}}', n);
      } else if (out.includes('{{amount_with_comma_separator}}')){
        const n = val.toFixed(2).replace('.', ',');
        out = out.replace('{{amount_with_comma_separator}}', withThousands(n, '.'));
      } else if (out.includes('{{amount_no_decimals}}')){
        const n = Math.round(val).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        out = out.replace('{{amount_no_decimals}}', n);
      } else if (out.includes('{{amount_with_apostrophe_separator}}')){
        const n = withThousands(val.toFixed(2), "'");
        out = out.replace('{{amount_with_apostrophe_separator}}', n);
      } else {
        const n = withThousands(val.toFixed(2), ',');
        out = out.replace('{{amount}}', n);
      }
      return cents < 0 ? '-' + out : out;
    }
    function fmtMoney(cents){
      try{
        if (window.Shopify && typeof Shopify.formatMoney === 'function'){
          return MONEY_FORMAT ? Shopify.formatMoney(cents, MONEY_FORMAT) : Shopify.formatMoney(cents);
        }
      }catch(_){}
      return fmtFromPattern(cents, MONEY_FORMAT);
    }

    // Product JSON
    const productEl = root.querySelector('[id^="ProductJson-"]');
    if(!productEl){ return; }
    let product;
    try { product = JSON.parse(productEl.textContent); }
    catch(e){ log('Product JSON parse error', e); return; }
    if(!product || !product.variants){ return; }

    // Finish map (for finishing helper image)
    const mapEl = root.querySelector('script[id^="FinishImageMap-"]');
    let finishMap = {};
    if(mapEl){
      try { finishMap = JSON.parse(mapEl.textContent || '{}'); }
      catch(e){ log('Finish map parse error', e); }
    }

    const form      = root.querySelector('#product-form');
    const varInput  = form ? form.querySelector('[data-variant-id]') : null;
    const priceWrap = root.querySelector('[data-price]');
    const addBtn    = form ? form.querySelector('.bls-add') : null;

    // Gallery nodes
    const mediaMain = root.querySelector('.bls-media-main');
    const mainImg   = mediaMain ? mediaMain.querySelector('.bls-main-img') : null;
    const thumbList = root.querySelector('#bls-thumbs-list');
    const thumbBtns = Array.from(root.querySelectorAll('.bls-thumb'));
    const upBtn     = root.querySelector('.bls-thumbs-scroll.up');
    const downBtn   = root.querySelector('.bls-thumbs-scroll.down');
    const prevBtn   = mediaMain ? mediaMain.querySelector('.bls-arrow-prev') : null;
    const nextBtn   = mediaMain ? mediaMain.querySelector('.bls-arrow-next') : null;

    function findVariantByOptions(options){
      return product.variants.find(v => product.options.every((opt, i) => v['option'+(i+1)] === options[i]));
    }
    function getSelectedOptions(){
      const groups = Array.from(root.querySelectorAll('.bls-option'));
      return groups.map(g => {
        const checked = g.querySelector('input[type="radio"]:checked');
        return checked ? checked.value : null;
      });
    }
    function markActiveThumb(id){
      thumbBtns.forEach(b => b.classList.toggle('is-active', Number(b.getAttribute('data-media-id')) === Number(id)));
      // ensure active thumb is visible in rail
      const active = thumbBtns.find(b => b.classList.contains('is-active'));
      if (active && thumbList){
        const railRect = thumbList.getBoundingClientRect();
        const tRect = active.getBoundingClientRect();
        if (tRect.top < railRect.top){
          thumbList.scrollBy({ top: tRect.top - railRect.top - 8, behavior: 'smooth' });
        } else if (tRect.bottom > railRect.bottom){
          thumbList.scrollBy({ top: tRect.bottom - railRect.bottom + 8, behavior: 'smooth' });
        }
      }
    }

    function updateUIForVariant(v){
      if(!v) return;
      if(varInput) varInput.value = v.id;

      // Price
      if(priceWrap){
        const cur   = priceWrap.querySelector('.bls-price-current');
        const comp  = priceWrap.querySelector('.bls-price-compare');
        const badge = priceWrap.querySelector('.bls-sale-badge');
        if(cur) cur.textContent = fmtMoney(v.price);
        if(comp){
          if(v.compare_at_price && v.compare_at_price > v.price){
            comp.textContent = fmtMoney(v.compare_at_price);
            comp.style.display = '';
          } else comp.style.display = 'none';
        }
        if(badge){
          if(v.compare_at_price && v.compare_at_price > v.price){
            const pct = Math.round((1 - v.price / v.compare_at_price) * 100);
            const base = badge.dataset.base || (badge.textContent.split('–')[0] || 'SALE').trim();
            badge.dataset.base = base;
            badge.textContent = pct>0 ? `${base} – ${pct}% OFF` : base;
            badge.style.display = '';
          } else {
            badge.style.display = 'none';
          }
        }
      }

      // Add button
      if(addBtn){
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? 'Add to cart' : 'Sold out';
      }

      // Main image to variant media (if present)
      try{
        if(!mainImg) return;
        const media = (v.featured_media && product.media.find(x=>x.id===v.featured_media.id)) || product.media[0];
        if(media && media.preview_image && media.preview_image.src){
          mainImg.src = media.preview_image.src;
          mainImg.setAttribute('data-media-id', media.id);
          mainImg.srcset = '';
          markActiveThumb(media.id);
        }
      }catch(e){ log('Image swap error', e); }
    }

    // Variant change handling
    root.addEventListener('change', (e) => {
      if(!e.target.matches('.bls-option input[type="radio"]')) return;

      refreshSwatchSelection();

      const selected = getSelectedOptions();
      if(selected.some(v => !v)) return;

      const v = findVariantByOptions(selected);
      if(v) updateUIForVariant(v);

      // Finishing helper swap
      const group = e.target.closest('.bls-option');
      if(group){
        const legend = group.querySelector('legend');
        if(legend && legend.textContent.toLowerCase().includes('finish')){
          updateFinishImage();
        }
      }
    });

    // Thumbnail clicks
    thumbBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        if(!mainImg) return;
        const id = Number(btn.getAttribute('data-media-id'));
        const m = product.media.find(x => x.id === id);
        if(m && m.preview_image && m.preview_image.src){
          mainImg.src = m.preview_image.src;
          mainImg.setAttribute('data-media-id', m.id);
          mainImg.srcset = '';
          markActiveThumb(id);
        }
      });
    });

    // Rail scroll buttons
    if (thumbList && upBtn) {
      upBtn.addEventListener('click', (e)=>{ e.preventDefault(); thumbList.scrollBy({ top: -200, left: 0, behavior: 'smooth' }); });
    }
    if (thumbList && downBtn) {
      downBtn.addEventListener('click', (e)=>{ e.preventDefault(); thumbList.scrollBy({ top: 200, left: 0, behavior: 'smooth' }); });
    }

    // Arrow navigation
    function gotoRel(dir){
      if(!mainImg) return;
      const curId = Number(mainImg.getAttribute('data-media-id'));
      const idx = product.media.findIndex(m => Number(m.id) === curId);
      if(idx === -1) return;
      let nextIdx = dir === 'prev' ? idx - 1 : idx + 1;
      if(nextIdx < 0) nextIdx = product.media.length - 1;
      if(nextIdx >= product.media.length) nextIdx = 0;
      const m = product.media[nextIdx];
      if(m && m.preview_image && m.preview_image.src){
        mainImg.src = m.preview_image.src;
        mainImg.setAttribute('data-media-id', m.id);
        mainImg.srcset = '';
        markActiveThumb(m.id);
      }
    }
    if(prevBtn) prevBtn.addEventListener('click', (e)=>{ e.stopPropagation(); gotoRel('prev'); });
    if(nextBtn) nextBtn.addEventListener('click', (e)=>{ e.stopPropagation(); gotoRel('next'); });

    // CLICK-TO-ZOOM ONLY (no hover zoom)
    if(mediaMain && mainImg){
      mediaMain.addEventListener('click', (e) => {
        if(e.target.closest('.bls-arrow')) return; // ignore arrow clicks
        mediaMain.classList.toggle('is-zoomed');
      });
      mediaMain.addEventListener('mousemove', (e) => {
        if(!mediaMain.classList.contains('is-zoomed')) return;
        const r = mediaMain.getBoundingClientRect();
        mediaMain.style.setProperty('--x', ((e.clientX - r.left)/r.width*100)+'%');
        mediaMain.style.setProperty('--y', ((e.clientY - r.top)/r.height*100)+'%');
      });
      document.addEventListener('keydown', (e)=>{ if(e.key === 'Escape') mediaMain.classList.remove('is-zoomed'); });
    }

    // Finishing helper image swap
    const infoMedia = root.querySelector('.bls-info-media');
    const infoImg   = infoMedia ? infoMedia.querySelector('.bls-info-img') : null;
    const infoCap   = root.querySelector('.bls-info-cap');

    function findFinishGroup(){
      const groups = Array.from(root.querySelectorAll('.bls-option'));
      return groups.find(g => {
        const legend = g.querySelector('legend');
        const name = legend ? legend.textContent.trim().toLowerCase() : '';
        return name.includes('finish');
      }) || null;
    }

    function updateFinishImage(){
      if(!infoImg || !finishMap || !Object.keys(finishMap).length) return;
      const finishGroup = findFinishGroup();
      if(!finishGroup) return;
      const checked = finishGroup.querySelector('input[type="radio"]:checked');
      if(!checked) return;

      const handle = checked.getAttribute('data-value-handle')
        || (checked.value || '').toString().trim().toLowerCase().replace(/\s+/g,'-');
      const entry = finishMap[handle];
      if(!entry || !entry.src) return;

      infoImg.src = entry.src;
      infoImg.srcset = '';
      if(infoCap){
        if(entry.caption){ infoCap.textContent = entry.caption; infoCap.style.display = ''; }
        else { infoCap.textContent = ''; infoCap.style.display = 'none'; }
      }
    }

    function refreshSwatchSelection(){
      root.querySelectorAll('.bls-option').forEach(group => {
        group.querySelectorAll('.bls-swatch').forEach(lbl => {
          const inp = lbl.querySelector('input[type="radio"]');
          lbl.classList.toggle('is-selected', !!(inp && inp.checked));
        });
      });
    }

    // Initial state
    const defaultVariant = product.selected_or_first_available_variant || product.variants[0];
    if(defaultVariant) updateUIForVariant(defaultVariant);
    updateFinishImage();
    refreshSwatchSelection();
  }
})();
/* ==== BEGIN: BLS ASK FORM VARIANT SYNC ==== */
(function () {
  function setAskHiddenFields(v) {
    var vTitleEl = document.querySelector('[data-question-variant]');
    var vSkuEl = document.querySelector('[data-question-sku]');
    if (!vTitleEl || !vSkuEl || !v) return;
    vTitleEl.value = v.title || '';
    vSkuEl.value = v.sku || '';
  }

  // Try to read current variant from your existing JSON or state
  function currentVariant() {
    // If your code stores the active variant somewhere, read it; fallback to selected option(s)
    try {
      var json = document.getElementById('ProductJson-{{ section.id }}');
      if (json) {
        var product = JSON.parse(json.textContent);
        // naive resolver by selected ID if present in a hidden input:
        var idInput = document.querySelector('[data-variant-id]');
        var id = idInput && idInput.value;
        if (id) {
          return product.variants.find(function (x) { return String(x.id) === String(id); });
        }
      }
    } catch (e) {}
    return null;
  }

  // Initial fill
  document.addEventListener('DOMContentLoaded', function(){
    setAskHiddenFields(currentVariant());
  });

  // Hook into variant changes: listen to change events on option inputs and the hidden variant id
  document.addEventListener('change', function(e){
    if (
      e.target.matches('input[name^="options["], select[name^="options["]') ||
      e.target.matches('[data-variant-id]')
    ) {
      setTimeout(function(){ setAskHiddenFields(currentVariant()); }, 0);
    }
  });
})();
/* ==== END: BLS ASK FORM VARIANT SYNC ==== */


/* ==== BEGIN: BLS TABS SCRIPT ==== */
(function () {
  const tablist = document.querySelector('[data-tablist]');
  if (!tablist) return;

  const tabs = Array.from(tablist.querySelectorAll('[data-tab]'));
  const panels = Array.from(document.querySelectorAll('.bls-tabpanel'));

  function activateTab(tabName) {
    tabs.forEach(btn => {
      const active = btn.dataset.tab === tabName;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-selected', String(active));
      btn.setAttribute('tabindex', active ? '0' : '-1');
    });

    panels.forEach(panel => {
      const isTarget = panel.id === `bls-panel-${tabName}`;
      panel.classList.toggle('is-active', isTarget);
      if (isTarget) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', 'hidden');
      }
    });
  }

  tablist.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-tab]');
    if (!btn) return;
    activateTab(btn.dataset.tab);
  });

  // Keyboard support (ArrowLeft/Right, Home/End)
  tablist.addEventListener('keydown', (e) => {
    const currentIndex = tabs.findIndex(t => t.classList.contains('is-active'));
    if (e.key === 'ArrowRight') {
      e.preventDefault();
      const next = tabs[(currentIndex + 1) % tabs.length];
      next.focus(); activateTab(next.dataset.tab);
    } else if (e.key === 'ArrowLeft') {
      e.preventDefault();
      const prev = tabs[(currentIndex - 1 + tabs.length) % tabs.length];
      prev.focus(); activateTab(prev.dataset.tab);
    } else if (e.key === 'Home') {
      e.preventDefault(); tabs[0].focus(); activateTab(tabs[0].dataset.tab);
    } else if (e.key === 'End') {
      e.preventDefault(); tabs[tabs.length - 1].focus(); activateTab(tabs[tabs.length - 1].dataset.tab);
    }
  });

  // Ensure first tab is active on load
  const first = tabs[0];
  if (first) activateTab(first.dataset.tab);
})();
 /* ==== END: BLS TABS SCRIPT ==== */
